<template>
  <section class="home-bed">
    <div class="img-bed">
      <black-bar :ifCanBack="false" :title="title">
      </black-bar>
    </div>
    <p style="margin-top:5vh">移动卡就是交通卡</p>
    <p style="color:#999999;margin-top:1vh">没网没电也能用，直接刷手机即可</p>
    <div style="width:60%;margin-left:20%">
      <img src="../assets/img/noAccess/img_wait.png"
           alt="">
    </div>
    <div class="word">
      <span style="color: #282B29;">正在写入数据...</span>
      <span style="color: #333333;">{{num}}%</span>
    </div>
    <div class="progress">
      <div class="light"
           :style="{width: num +'%'}"></div>
    </div>

  </section>
</template>

<script>
import blackBar from '@/components/blackBar'
export default {
  name: 'writingOpen',
  data () {
    return {
      loading: true,
      num: 20,
      title: "充值",

    }
  },
  components: {
    blackBar
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  mounted () {
    // if (this.$route.params) {
    //   if (this.$route.params.type == 'pay') {
    //     this.title = '充值'
    //   } else {
    //     this.title = '开卡激活'
    //   }
    // }
    const that = this;
    window.chargeProcess = that.chargeProcess;
  },
  methods: {
    chargeProcess (val) {
      if (val.code == '0000') {
        this.num = val.data.chargeProcess;
      } else {
        this.$eventBus.$emit('getTipsInfo', {
          msg: val.message
        })
      }
    },
    goRouter () {
      if (this.title == '充值') {
        this.$router.push({
          name: 'paySuccess'
        })

      } else {
        this.$router.push({
          name: 'openSuccess'
        })
      }
      // if (this.loading) {
      //   this.$router.push({
      //     name: router
      //   })
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  text-align: center;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  // height: 320px;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
p {
  font-size: 26px;
  font-weight: 400;
  color: #333333;
}
.word {
  width: 92%;
  height: 37px;
  line-height: 37px;
  margin-left: 4%;
  margin-top: 10vh;
  display: flex;
  justify-content: space-between;
}
.progress {
  width: 92%;
  height: 12px;
  margin-top: 8px;
  margin-left: 4%;
  background: #e8e8e8;
  border-radius: 6px 6px 6px 6px;
}
.light {
  background-color: #4a8ef7;
  height: 100%;
  border-radius: 6px 6px 6px 6px;
}
img {
  margin-top: 67px;
  width: 100%;
}
</style>
